<!--
 All Results Computer
 Component show all results with pagination in table style for computer only.
 devs@droxit.de
 Copyright (c) 2021 droxIT GmbH
-->
<template>
<b-container fluid="md">
      <table class="table-bordered" style="width: 100%">
        <thead>
          <b-tr>
            <b-th style="padding-top: 20px; border-bottom-width: 1px;">
              <b-row class="rocketsearch-column-header">
                <b-col style="padding-left: 15px;">
                  <p class="rocketsearch-column-header-text">{{$t('search_results')}}</p>
                  <p class="rocketsearch-column-show-all">
                    <span class="rocketsearch-text-show-all" v-on:click="$emit('showAll')" style="font-weight: lighter">{{$t('back_to_start')}}</span>
                  </p>
                </b-col>
              </b-row>
            </b-th>
          </b-tr>
        </thead>
        <b-tr>
          <b-td cols="12" id="rocketsearch-result-column" style="border-bottom-color: white; vertical-align: top;">
            <ResultList :results=results  :showAllResults="true" />
            <b-pagination id="rocketsearch-result-pagination"
              v-model="currPage"
              :total-rows="hits"
              :per-page="searchSize"
              @input ="$root.$emit('TurnPage', currPage)"
              align="center"
            ></b-pagination>
          </b-td>
        </b-tr>
        <b-tr id="rocketsearch-footer" style="border-bottom-color: white; vertical-align: top;">
          <b-td id="rocketsearch-powered" style=" padding-top: 0; padding-left: 25px; padding-bottom: 8px;">
            <a href="https://rocketsearch.eu/" target="_blank">
              <span id="rocketsearch-grey-text">powered by </span>
              <span id="rocketsearch-green-text">rocket </span>
              <span id="rocketsearch-blue-text"> search</span>
            </a>
          </b-td>
        </b-tr>
      </table>
    </b-container>
</template>

<script>
import ResultList from "./ResultList";

export default {
  name: "AllResultsComputer",
  props: {
    searchTerm: String,
    currentPage: Number,
    results: Object,
    hits: Number,
  },
  components: {
    ResultList
  },
  data: function (){
    return {
      currPage: this.currentPage,
      searchSize: window.__env.config.NUM_ALL_RESULTS,
    }
  },
  methods: {
   }
}
</script>

<style scoped>

</style>